module.exports = __webpack_public_path__ + "static/media/fair-ill.99ccf563.svg";